module.exports = __webpack_public_path__ + "media/images/salespartner/flow_sp-b98c7451ce19355d2fcb9bc166145633.svg";